export default {
  PageHeading: "Statements",
  EmptyStatementsHeading: "No statements to see yet",
  EmptyStatementsDescription: "After your first calendar month with Kolmeo, your statements will begin showing here."
};
